import { createSlice } from "@reduxjs/toolkit";
// utils
import { Bounce, toast } from "react-toastify";
import axiosInstance from "../../utils/axios";
import { getFirstLineUps, getSecondLineUps } from "./lineup";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  activity: null,
  firstTeamActivities: [],
  secondTeamActivities: [],
  fetchLoading: false,
  activities: [],
  activityTime: null,
};

const slice = createSlice({
  name: "activities",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    starFetchtLoading(state) {
      state.fetchLoading = true;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
      state.fetchLoading = false;
    },

    // GET DATA success

    getActivitiesSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.activities = action.payload;
    },

    getFirstActivitiesSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.firstTeamActivities = action.payload;
    },

    getSecondActivitiesSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.secondTeamActivities = action.payload;
    },

    // POST DATA success
    postActivitiesSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.activities = [...action.payload.data, ...state.activities];
      action.payload.resetDoOrDie && action.payload.resetDoOrDie();
      // if (action.payload.isFirstTeam) {
      //   state.firstTeamActivities = [
      //     action.payload.data,
      //     ...state.firstTeamActivities,
      //   ];
      // } else {
      //   state.secondTeamActivities = [
      //     action.payload.data,
      //     ...state.secondTeamActivities,
      //   ];
      // }
    },

    deleteActivitySuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.activities = state.activities.filter(
        (act) => act.id !== action.payload
      );
    },

    updateActivitySuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.activities = state.activities.map((act) => {
        if (act.id === action.payload.id) {
          return action.payload;
        } else {
          return act;
        }
      });
    },

    updateActivityTimeSuccess(state, action) {
      state.activityTime = action.payload;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default slice.reducer;

// TODO: get activities``
export function getActivities({ team_id, game_id, player_id, type }) {
  return async (dispatch) => {
    dispatch(slice.actions.starFetchtLoading());
    try {
      const response = await axiosInstance.get(`activities`, {
        params: {
          team_id,
          game_id,
          player_id,
          type,
          j: true,
        },
      });
      dispatch(slice.actions.getActivitiesSuccess(response.data.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: update activities``
export function updateActivity({
  team_id,
  game_id,
  player_id,
  type,
  activity_id,
  points,
  setOpenEdit,
  singleGame,
  season_id,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.patch(`activities/${activity_id}`, {
        team_id,
        game_id,
        player_id,
        type,
        points,
      });
      dispatch(
        getFirstLineUps({
          team_slug: singleGame?.first_team?.id,
          game_slug: singleGame?.id,
          a: true,
          j: true,
          season_id,
        })
      );

      dispatch(
        getSecondLineUps({
          team_slug: singleGame?.second_team?.id,
          game_slug: singleGame?.id,
          a: true,
          j: true,
          season_id,
        })
      );
      setOpenEdit(false);
      dispatch(slice.actions.updateActivitySuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: get activities``
export function getFirstTeamActivities({ team_id, game_id, player_id, type }) {
  return async (dispatch) => {
    dispatch(slice.actions.starFetchtLoading());
    try {
      const response = await axiosInstance.get(`activities`, {
        params: {
          team_id,
          game_id,
          player_id,
          type,
          j: true,
        },
      });

      dispatch(
        slice.actions.getFirstActivitiesSuccess(response.data.data.data)
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: get activities``
export function getSecondTeamActivities({ team_id, game_id, player_id, type }) {
  return async (dispatch) => {
    dispatch(slice.actions.starFetchtLoading());
    try {
      const response = await axiosInstance.get(`activities`, {
        params: {
          team_id,
          game_id,
          player_id,
          type,
          j: true,
        },
      });
      dispatch(
        slice.actions.getSecondActivitiesSuccess(response.data.data.data)
      );
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function postActivity({
  data,
  isFirstTeam,
  toastMessage,
  singleGame,
  season_id,
  setOpen,
  resetDoOrDie,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(`activities`, data);
      dispatch(
        slice.actions.postActivitiesSuccess({
          data: response.data.data,
          isFirstTeam,
          resetDoOrDie,
        })
      );

      toast.success(toastMessage, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      dispatch(
        getFirstLineUps({
          team_slug: singleGame?.first_team?.id,
          game_slug: singleGame?.id,
          a: true,
          j: true,
          season_id,
        })
      );

      dispatch(
        getSecondLineUps({
          team_slug: singleGame?.second_team?.id,
          game_slug: singleGame?.id,
          a: true,
          j: true,
          season_id,
        })
      );

      dispatch(
        getActivities({
          game_id: singleGame?.id,
        })
      );
      setOpen && setOpen(false);
    } catch (error) {
      toast.error(error.message || "Error", {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      // toast.error(error.message || "Error");
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteActivity({
  activity_id,
  toastMessage,
  singleGame,
  setOpenDelete,
  season_id,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axiosInstance.delete(`activities/${activity_id}`);
      dispatch(slice.actions.deleteActivitySuccess(activity_id));

      toast(toastMessage, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

      dispatch(
        getFirstLineUps({
          team_slug: singleGame?.first_team?.id,
          game_slug: singleGame?.id,
          a: true,
          season_id,
          j: true,
        })
      );

      dispatch(
        getSecondLineUps({
          team_slug: singleGame?.second_team?.id,
          game_slug: singleGame?.id,
          a: true,
          j: true,
        })
      );
      setOpenDelete(false);
    } catch (error) {
      setOpenDelete(false);
      toast.error(error.message || "Error", {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

// TODO: activity time

export function updateActivityTime({ time }) {
  return async (dispatch) => {
    try {
      dispatch(slice.actions.updateActivityTimeSuccess(time));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
